import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ComponentBase, Changeable } from 'common';
import { ApiKeyDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { DateService } from 'base';


@Component({
    selector: 'apikey',
	templateUrl: './apikey.component.html',
	styleUrls: ['./apikey.component.scss'],
})
export class ApiKeyComponent extends ComponentBase implements OnChanges, Changeable {

	@Input()
	public target: ApiKeyDto;

	@Input()
	public create: boolean;

	public form: UntypedFormGroup;

	public guid: UntypedFormControl;
	public name: UntypedFormControl;
	public active: UntypedFormControl;
	public lastActivity: UntypedFormControl;
	public clientIpScope: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder, private dateService: DateService) {

		super();
		this.buildForm();
	}

	public getIsActive(): boolean {
		return this.active.value;
	}

	private buildForm(): void {

		let guid = "";
		let name = "";
		let active = false;
		let lastActivity = "";
		let clientIpScope = "";

		if (this.target) {
			guid = this.target.Guid;
			name = this.target.Name;
			active = this.target.IsActive;
			lastActivity = this.dateService.formatDateHm(this.target.LastActivityTime);
			clientIpScope = this.target.ClientIpScope.ToString();
		}

		this.guid = new UntypedFormControl(guid);
		this.name = new UntypedFormControl(name, Validators.required);
		this.active = new UntypedFormControl(active);
		this.lastActivity = new UntypedFormControl(lastActivity);
		this.clientIpScope = new UntypedFormControl(clientIpScope);

		this.form = this.fb.group({
			guid: this.guid,
			name: this.name,
			active: this.active,
			lastActivity: this.lastActivity,
			clientIpScope: this.clientIpScope,
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildForm();
	}

	public get enableApply(): boolean {
		return (this.tempChanges && this.tempChangesValid);
	}

	public get tempChanges(): boolean {
		return this.form.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.form.valid;
	}

	public get invalidTempChanges(): string[] {
		let result: string[] = [];
		if (!this.form.valid) {
			result.push("API Key");
		}
		return result;
	}

	public applyTempChanges(): void {
		if (this.target) {
			this.getChanges(this.target);
			this.buildForm();
		}
	}

	public discardTempChanges(): void {
		this.buildForm();
	}

	private getChanges(apiKey: ApiKeyDto): void {
		apiKey.Guid = this.guid.value;
		apiKey.Name = this.name.value;
		apiKey.IsActive = this.active.value;
		apiKey.LastActivityTime = this.lastActivity.value;
		apiKey.ClientIpScope.FromString(this.clientIpScope.value);
	}

}
